import { debounce, uniq } from 'lodash';
import { ParticipantOption } from '@domain/districts';
import { DynamicData } from '@domui-domain/type';

export type ConferenceData = {
  ConferenceExistingOrganizationPks: string[];
};

export default debounce(
  async (
    value: ParticipantOption[],
    getPRFeedbackAdditionalOrganization: ({
      OrganizationPks,
      RotaryYears,
    }: {
      OrganizationPks: string[];
      RotaryYears: string;
    }) => Promise<ConferenceData>,
    getConferenceData: () => ConferenceData | null | undefined,
    setInvalidParticipants: (ids: string[]) => void,
    setErrorCallback: () => void,
    clearErrorCallback,
    excludeIdsFromValidation?: string[],
    conferenceRY?: string,
    isValidating?: (b: boolean) => void
  ) => {
    const RY = Number(conferenceRY);
    const minStartDate = `${RY - 1}-07-01`;
    const maxStartDate = `${RY}-06-30`;
    let selectedIds = value.map(({ id }) => id);

    if (excludeIdsFromValidation?.length) {
      selectedIds = selectedIds.filter(
        id => !excludeIdsFromValidation.includes(id)
      );
    }
    const startYear = new Date(minStartDate).getFullYear();
    const endYear = new Date(maxStartDate)
      .getFullYear()
      .toString()
      .slice(-2);

    const RotaryYears = `${startYear}-${endYear}`;
    isValidating?.(true);
    try {
      const response: DynamicData = await getPRFeedbackAdditionalOrganization({
        OrganizationPks: selectedIds,
        RotaryYears,
      });

      const conferences = response?.ConferenceExistingOrganizationPks ?? [];

      const invalidIds = conferences.filter((id: string) =>
        selectedIds.includes(id)
      );
      const uniqueIds: string[] = uniq(invalidIds);
      setInvalidParticipants(uniqueIds);

      if (uniqueIds.length) {
        setErrorCallback();
      } else {
        clearErrorCallback();
      }
    } catch (err) {
      console.error('Validation failed:', err);
      setErrorCallback();
    } finally {
      isValidating?.(false);
    }
  },
  500
);
